export default function Logo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" rx="22" fill="#3B6EF6"/>
      <text x="50" y="67" textAnchor="middle"
        fontFamily="Georgia,'Times New Roman',serif"
        fontSize="56" fontWeight="700" fill="white">A</text>
      <text x="80" y="40" textAnchor="middle"
        fontFamily="Georgia,'Times New Roman',serif"
        fontSize="26" fontWeight="400" fill="#93B4FF">+</text>
    </svg>
  )
}